// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"64dae71d","476":"40d58b71"}[chunkId] + ".chunk.css";
};